import InitialState from "../../InitialState";
import * as types from "./ActionTypes";

export default function studentProgrammingReducer(state = InitialState.studentprogramming, action) {
    switch(action.type) {
        case types.STUDENT_UPDATE_SELECTED_LAB:
            return {
                selected_lab: action.payload.data,
                //selected_program: null,
                //selected_submission: null
            }
        
        case types.STUDENT_UPDATE_SELECTED_PROGRAM:
            return {
                ...state,
                selected_program: action.payload.data,
                //selected_submission: null
            }
        
        case types.STUDENT_UPDATE_SELECTED_SUBMISSION:
            return {
                ...state,
                selected_submission: action.payload.data
            }

        default:
            return state
    }
}